<div class="_administration-desktop-page">

	<segment-desktop-component [segments]="segments" [selectedSegment]="selectedSegment" (selectedSegmentChange)="onSelectedSegmentChange($any($event))"></segment-desktop-component>

	<ng-container [ngSwitch]="selectedSegment">

		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[0])">
			<locations-component></locations-component>
		</div>

		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[1])">
			<event-types-component></event-types-component>
		</div>

		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[2])">
			<device-types-component></device-types-component>
		</div>

		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[3])">
			<message-box-component [key]="MessageBoxKey.clientOrigins">
				<p content>{{'MESSAGE_BOX.CLIENT_ORIGINS' | translate}}</p>
			</message-box-component>
			<client-origins-component></client-origins-component>
		</div>		

		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[4])">
			<question-categories-component></question-categories-component>
		</div>	

		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[5])">
			<digibank-agencies-component></digibank-agencies-component>
		</div>

		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[6])">
			<target-audiences-component></target-audiences-component>
		</div>	

		<div class="_segmented-component" *ngSwitchCase="getSegmentName(this.segments[7])">
			<message-box-component [key]="MessageBoxKey.cancellationReasons">
				<p content>{{'MESSAGE_BOX.CANCELLATION_REASONS' | translate}}</p>
			</message-box-component>
			<cancellation-reasons-component></cancellation-reasons-component>
		</div>	

	</ng-container>

</div>
